import React from 'react'
import JsonUpload from '../JsonUpload'

const ProjectsImportButton: React.FC = () => (
  <>
    <JsonUpload />
  </>
)

export default ProjectsImportButton
